const NOT_ALLOWED_CHARACTERS = ["<", ">", ":", '"', "\\", "|", "?", "*", "/"];

export const containsInvalidCharacters = (value: string): boolean => {
  if (!value) return false;
  const stringValue = value.toString();
  return NOT_ALLOWED_CHARACTERS.some((character) => stringValue.includes(character));
};

export const getFirstInvalidCharacter = (value: string): string => {
  if (!value) return "";
  const stringValue = value.toString();
  for (const character of stringValue) {
    if (NOT_ALLOWED_CHARACTERS.includes(character)) {
      return character;
    }
  }

  return "";
};
